var m = require('mithril');
var Model = require('../../libs/Model');
var passwordInput = require('../../components/inputs/passwordInput');
var passwordPolicy = require('../../../../../models/users/passwordPolicy');

var user = Object.create(Model)

user.name = 'User';
user['@class'] =  'User'
user.url = 'user'

user.fields = {
  password: {
    validators: {
      length: {minimum: 6, maximum: 128},
    }
  },
  confirmPassword: {
    validators: {
      equality: {
        attribute:'password',
        message: "Passwords must match"
      }
    }
  }
};

function rejectWithErrors(errors) {
  user.errors = errors;
  m.redraw();
  return Promise.reject(errors);
}

user.save = function () {
  var password = user.form && user.form.password ? user.form.password() : null;
  var confirmPassword = user.form && user.form.confirmPassword ? user.form.confirmPassword() : null;

  if (!password) {
    return rejectWithErrors(['Password is required']);
  }

  if (!confirmPassword) {
    return rejectWithErrors(['Confirm password is required']);
  }

  if (password !== confirmPassword) {
    return rejectWithErrors(['Passwords must match']);
  }

  if (!passwordPolicy.isStrongPassword(password)) {
    return rejectWithErrors([passwordPolicy.STRONG_PASSWORD_MESSAGE]);
  }

  return Model.save.call(user);
};

user.view = function () {
  return m("form", {role:"form"}, [
    m('h4', 'Update Password'),
    user.errorView(),
    m(passwordInput, {
      field: { id: 'password', name: 'Password' },
      prop: user.form.password,
      autocomplete: 'new-password'
    }),
    m(passwordInput, {
      field: { id: 'confirm-password', name: 'Confirm Password' },
      prop: user.form.confirmPassword,
      autocomplete: 'new-password'
    })
  ]);
};

module.exports = user;
